import Box from '@mui/joy/Box';
import PlusIcon from '../../assets/images/plus.svg?react';

interface RunTestAddRowProps {
  handleCreate: () => void;
  disabled?: boolean;
}

const RunTestAddRow = ({ handleCreate, disabled }: RunTestAddRowProps) => {
  return (
    <Box display={'flex'} justifyContent={'flex-start'}>
      <button className="run-test-plus-btn" type="button" onClick={handleCreate} disabled={disabled}>
        <PlusIcon className="plus-icon" />
      </button>
    </Box>
  );
};

export default RunTestAddRow;
